export const logout = () => {
    sessionStorage.removeItem("apayroucarayxczijiuhxvkdsp");
    sessionStorage.removeItem('theme-dark')
    sessionStorage.removeItem('permissions')
    sessionStorage.removeItem('role')
    window.location.href = '/'
}